<template>
  <div>
    <div class="opo02">
      <span class="opo03" @click="toBack()">设备列表 ></span>
      <span class="opo04"> 设备状态查看</span>
    </div>
    <div class="djt351" v-if="styles == 0">
      <div style="width: 50%;display: flex;align-items: center;">
        <div>
          <el-date-picker
            v-model="days"
            type="daterange"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            @change="handleDate"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div class="djt351-1" @click="xdTime()">确定</div>
      </div>
      <div class="djt351-1 djt351-2" title="导出Excel" @click="toExcel">
        <img src="@/assets/imgs/08.png" alt="" class="djt351-3">
        <span>导出表格</span>
      </div>
    </div>
    <div class="djt361">
      <div @click="qiehuan(0)" :class="[styles == 0? 'active' : '']" class="djt36-1">存储记录</div>
      <div @click="qiehuan(1)" :class="[styles == 1? 'active' : '']" class="djt36-2">故障记录</div>
    </div>
    <div class="djt05" v-if="styles == 0" style="margin-top: 10px">
      <div class="djt06">
        <div class="djt26" style="width: 12%">刀具名称</div>
        <div class="djt26" style="width: 12%">刀具编码</div>
        <div class="djt26" style="width: 12%">刀具型号</div>
        <div class="djt26" style="width: 12%">单位</div>
        <div class="djt26" style="width: 12%">期初结存数量</div>
        <div class="djt26" style="width: 12%">补货数量</div>
        <div class="djt26" style="width: 12%">发放数量</div>
        <div class="djt26" style="width: 12%">期末结存</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09s" v-for="(item,index) in datas" :key="'lls'+index">
            <div class="djt27" style="width: 12%;">{{item.goodsname}}</div>
            <div class="djt27" style="width: 12%;">{{item.goodscode}}</div>
            <div class="djt27" style="width: 12%;">{{item.model}}</div>
            <div class="djt27" style="width: 12%">{{item.unit}}</div>
            <div class="djt27" style="width: 12%">{{item.startnum}}</div>
            <div class="djt27" style="width: 12%">{{item.bcnum}}</div>
            <div class="djt27" style="width: 12%">{{item.lynum}}</div>
            <div class="djt27" style="width: 12%">{{item.endnum}}</div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09-1s" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage1"
          background
          :page-size="7"
          :pager-count="5"
          :total="total1"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
    <div class="djt05" v-else style="margin-top: 10px">
      <div class="djt06">
        <div class="djt26" style="width: 25%">类型</div>
        <div class="djt26" style="width: 25%">故障详情</div>
        <div class="djt26" style="width: 25%">设备状态</div>
        <div class="djt26" style="width: 25%">上报时间</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09s" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt27" style="width: 25%;" v-if="item.type == 1">出货机构</div>
            <div class="djt27" style="width: 25%;" v-if="item.type == 2">标签打印机</div>
            <div class="djt27" style="width: 25%;" v-if="item.type == 3">小票打印机</div>
            <div class="djt27" style="width: 25%" :title="item.msg">{{item.msg}}</div>
            <div class="djt27" style="width: 25%" v-if="item.state == 1">正常</div>
            <div class="djt27" style="width: 25%" v-if="item.state == 2">异常</div>
            <div class="djt27" style="width: 25%" :title="item.ctimestr">{{item.ctimestr}}</div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09-1s" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="7"
          :pager-count="7"
          :total="total2"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import https from "@/api/retrieve";
  import util from '@/util/util';
  export default {
    name: "djgls",
    data(){
      return{
        styles:0,
        total1:0,
        total2:0,
        loading:true,
        pageSize:7,
        page:1,
        data:[],
        sbid:'',
        end:'',
        start:'',
        days:[],
        datas:[],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '清空',
            onClick(picker) {
              picker.$emit('pick', ['', '']);
            }
          }]
        },
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      me.sbid = me.$route.query.id;
      // let data = {
      //   page:1,
      //   pageSize:me.pageSize,
      //   deviceid:me.sbid,
      // }
      // httpUser.getdevicefaultlist(data).then(res => {
      //   console.log(res);
      //   me.data = res.data;
      //   me.total2 = res.data.totalNum
      //   me.loading = false;
      // })
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth()+1
      var day = date.getDate()
      // var days = date.getDate()-7
      me.start = new Date(new Date().getTime()-7*24*3600*1000).toLocaleDateString()
      for(let i = 0;i<me.start.length;i++){
        if(me.start[i] == '/'){
          me.start = me.start.replace('/','-')
        }
      }
      me.end = year + '-' + month + '-'+ day
      // me.days[0] = me.start
      // me.days[1] = me.end
      me.days = [me.start,me.end]
      // console.log(me.days,"????")
      let data1 = {
        starttime:me.start,
        endtime:me.end,
        companyid:user.companyId,
        deviceid:me.sbid,
        page:me.page,
        pageSize:me.pageSize
      };
      https.getdevicesavelist(data1).then(res=>{
        me.datas = res.data.dataList
        me.total1 = res.data.totalNum
        me.loading = false;
      })
    },
    methods:{
      handleDate(t){
        if(t == null){
          me.days = []
        }
      },
      qiehuan(num){
        me.styles = num
        if(num == 1){
          let data = {
            page:1,
            pageSize:me.pageSize,
            deviceid:me.sbid,
          }
          httpUser.getdevicefaultlist(data).then(res => {
            // console.log(res);
            me.data = res.data;
            me.total2 = res.data.totalNum
            me.loading = false;
          })
        }else{
          let data = {
            starttime:me.start,
            endtime:me.end,
            companyid:user.companyId,
            deviceid:this.sbid,
            page:me.page,
            pageSize:me.pageSize
          };
          https.getdevicesavelist(data).then(res=>{
            me.datas = res.data.dataList
            me.total1 = res.data.totalNum
            me.loading = false;
          })
        }
      },
      toExcel(){
        if(me.days.length == 0) {
          me.$message.error('请输入开始时间和结束时间');
          return false;
        }
        me.$Loading.start();
        let data = {
          companyid:user.companyId,
          starttime:'',
          endtime:'',
          deviceid:this.sbid
        }
        if (me.days.length != 0) {
          data['starttime'] = me.days[0];
          data['endtime'] = me.days[1];
        }
        https.exportdjgsfcbb(data).then(res=>{
          const blob = new Blob([res],{ type: 'application/vnd.ms-excel'});//处理文档流
          const fileName = '刀具柜收发存报表.csv';
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          me.loading = false;
          me.$Loading.finish();
        })
      },
      xdTime(){
        me.loading = true;
        let data = {
          starttime:me.start,
          endtime:me.end,
          companyid:user.companyId,
          deviceid:me.sbid,
          page:me.page,
          pageSize:me.pageSize
        };
        if(me.days.length == 0) {
          me.$message.error('请输入开始时间和结束时间');
          return false;
        }
        if (me.days.length != 0) {
          data['starttime'] = me.days[0];
          data['endtime'] = me.days[1];
        }
        https.getdevicesavelist(data).then(res=>{
          me.datas = res.data.dataList
          me.total1 = res.data.totalNum
          me.loading = false;
        })
      },
      toBack(){
        me.$router.back();
      },
      toPage1(e){
        me.loading = true;
        let data1 = {
          starttime:me.start,
          endtime:me.end,
          companyid:user.companyId,
          deviceid:me.sbid,
          page:e,
          pageSize:me.pageSize
        };
        if (me.days.length != 0) {
          data1['starttime'] = me.days[0];
          data1['endtime'] = me.days[1];
        }
        https.getdevicesavelist(data1).then(res=>{
          me.datas = res.data.dataList
          me.total1 = res.data.totalNum
          me.loading = false;
        })
      },
      toPage(e){//分页
        me.loading = true;
        me.page = e;
        let data = {
          page:e,
          pageSize:me.pageSize,
          deviceid:me.sbid,
        }
        me.page = e;
        httpUser.getdevicefaultlist(data).then(res => {
          me.data = res.data;
          me.total2 = res.data.totalNum
          me.loading = false;
        })
      },
    }
  }
</script>

<style scoped>
@import "djgls.css";
</style>